<template>
  <div class="burger-link no-underline" @click="openBurger">
    <span class="burger-link-text"> {{ item.name }} </span>
    <img src="../../../../../assets/shop/nav-arrow.svg"
         class="burger-link-text-arrow"
         v-if="item.children_count"
         alt="link-icon"
         width="8"
         height="13"
         loading="eager"
         fetchpriority="high"
    >
    <span class="burger-link-count" v-else-if="showCounter"> {{ item.product_count }} </span>
  </div>
</template>

<script>
import { formatCategoryLink } from '@vue-storefront/core/modules/url/helpers'
import { mapGetters } from 'vuex'

export default {
  props: {
    item: {
      type: Object
    },
    showCounter: {
      type: Boolean,
      required: false,
      default: () => true
    }
  },
  computed: {
    ...mapGetters({
      currentPartner: 'partners/getCurrentPartner'
    }),
    currentPartnerCode () {
      return this.currentPartner.code
    },
    currentLocationCode () {
      return this.$route.params.locationCode
    }
  },
  methods: {
    categoryLink (category) {
      return `/${this.currentLocationCode}/${this.currentPartnerCode}${formatCategoryLink(category)}`
    },
    openBurger () {
      if (this.item.children_data.length) {
        const payload = {
          current_list: this.item.children_data,
          list_naming: this.item.name,
          product_count: this.item.product_count,
          current_category: this.item,
          root_category: this.item
        }
        this.$bus.$emit('open-burger', payload)
        this.$bus.$emit('burger-path', this.item)
      } else {
        this.$bus.$emit('hide-burger-menu')
        this.$bus.$emit('close-burger')
        this.$bus.$emit('hide-overlay-in-shop')
        this.$bus.$emit('change-close-btn')
        this.$router.push(this.categoryLink(this.item))
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.burger-link {
  width: 100%;
  padding: 15px 20px;

  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;

  box-sizing: border-box;

  &:before {
    width: 93%;
    height: 1px;
    margin: auto;

    position: absolute;
    bottom: 0;
    right: 0;
    content: '';

    background: rgba(159, 159, 159, .2);
  }

  &-text {
    color: #111;
    font-size: 14px;
    font-weight: 400;
  }

  &-arrow {

  }

  &-count {
    color: rgb(159, 159, 159);
    font-size: 12px;
    font-weight: 400;
  }
}
</style>
